import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf3d190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pptist-screen" }

import { onMounted, onUnmounted, ref } from 'vue'
import { KEYS } from '@/configs/hotkey'
import useScreening from '@/hooks/useScreening'

import BaseView from './BaseView.vue'
import PresenterView from './PresenterView.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const viewMode = ref<'base' | 'presenter'>('base')

const changeViewMode = (mode: 'base' | 'presenter') => {
  viewMode.value = mode
}

const { exitScreening } = useScreening()

// 快捷键退出放映
const keydownListener = (e: KeyboardEvent) => {
  const key = e.key.toUpperCase()
  if (key === KEYS.ESC) exitScreening()
}

onMounted(() => document.addEventListener('keydown', keydownListener))
onUnmounted(() => document.removeEventListener('keydown', keydownListener))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (viewMode.value === 'base')
      ? (_openBlock(), _createBlock(BaseView, {
          key: 0,
          changeViewMode: changeViewMode
        }))
      : (viewMode.value === 'presenter')
        ? (_openBlock(), _createBlock(PresenterView, {
            key: 1,
            changeViewMode: changeViewMode
          }))
        : _createCommentVNode("", true)
  ]))
}
}

})